import React from 'react';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => {
  return (
    <div className={`animate-pulse bg-gray-200 rounded ${className}`}></div>
  );
};

// Skeleton für Karten-Statistiken
export const SkeletonStatCard: React.FC = () => {
  return (
    <div className="card">
      <div className="flex items-center">
        <Skeleton className="w-8 h-8 rounded-full" />
        <div className="ml-4 flex-1">
          <Skeleton className="h-4 w-24 mb-2" />
          <Skeleton className="h-8 w-12" />
        </div>
      </div>
    </div>
  );
};

// Skeleton für Artikel-Eintrag
export const SkeletonArticleCard: React.FC = () => {
  return (
    <div className="relative flex flex-col md:flex-row md:items-stretch md:space-x-6 p-4 border border-gray-200 rounded-lg">
      {/* Bild Skeleton */}
      <Skeleton className="w-full md:w-44 h-48 md:h-28 mb-4 md:mb-0" />
      
      {/* Content Skeleton */}
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-32" />
          <div className="flex gap-2">
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-6 w-16" />
          </div>
        </div>
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <div className="flex gap-4">
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-3 w-40" />
        </div>
      </div>
    </div>
  );
};

// Skeleton für Schedule-Eintrag
export const SkeletonScheduleItem: React.FC = () => {
  return (
    <div className="flex items-center p-2 border border-gray-200 rounded-lg bg-blue-50">
      <Skeleton className="w-6 h-6 rounded-full" />
      <div className="ml-2 flex-1">
        <Skeleton className="h-3 w-32 mb-1" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
  );
};

